<div id="change-password" class="inner-scroll" fxLayout="row" fxLayoutAlign="start">

    <div id="change-password-intro" fxFlex fxHide fxShow.gt-xs>

        <div class="logo" [@animate]="{value:'*',params:{scale:'0.2'}}">
            <img src="assets/images/logos/svg/h-logotipo-ll-cinza.svg">
        </div>

        <div class="title" [@animate]="{value:'*',params:{delay:'50ms',y:'25px'}}">
            MÓDULO EXAMES
        </div>

        <div class="description" [@animate]="{value:'*',params:{delay:'100ms',y:'25px'}}">
            Conclua a alteração solicitada preenchendo sua senha atual, nova senha e a confirmação e pressione Confirmar.
        </div>

    </div>

    <div id="change-password-form-wrapper" fusePerfectScrollbar
         [@animate]="{value:'*',params:{delay:'300ms',x:'100%'}}">

        <div id="change-password-form">

            <div fxHide.gt-xs>
                <img src="assets/images/logos/svg/v-logotipo-ll-colorido.svg" style="width: 150px; padding-top: 20px; padding-bottom: 20px;" />
            </div>

            <div class="title">TROCAR SENHA</div>

            <form name="changePasswordForm" [formGroup]="changePasswordForm" novalidate>
                <mat-form-field>
                    <input matInput type="password" placeholder="Senha atual" formControlName="password">
                    <mat-error>
                        Preencha a senha atual
                    </mat-error>
                </mat-form-field>

                <mat-form-field>
                    <input matInput type="password" placeholder="Nova senha" formControlName="passwordNew">
                </mat-form-field>

                <mat-form-field>
                    <input matInput type="password" placeholder="Confirme sua senha" formControlName="passwordConfirm">
                    <mat-error *ngIf="changePasswordForm.get('passwordConfirm').hasError('required')">
                        Confirme a senha
                    </mat-error>
                    <mat-error *ngIf="!changePasswordForm.get('passwordConfirm').hasError('required') &&
                                       changePasswordForm.get('passwordConfirm').hasError('mustMatch')">
                         A confirmação está diferente da senha
                    </mat-error>
                </mat-form-field>

                <button mat-raised-button class="submit-button" color="accent" (click)="send()"
                        aria-label="Confirmar" [disabled]="changePasswordForm.invalid || loading">
                    Confirmar
                </button>
            </form>

            <div *ngIf="!loading && resetSenha" class="login" fxLayout="row" fxLayoutAlign="center center">
                <a class="link" [routerLink]="'app'">Voltar para o home</a>
            </div>

                            <!-- Requisitos de senha -->
                            <div class="password-requirements">
                                <p class="requirements-title">A senha deve conter:</p>
                                <ul class="requirements-list">
                                    <li [ngClass]="{
                                        'met': changePasswordForm.get('passwordNew').value.length >= 8,
                                        'not-met': changePasswordForm.get('passwordNew').value.length < 8
                                    }">
                                            8 caracteres no total
                                    </li>
                                    <li [ngClass]="{
                                        'met': !changePasswordForm.get('passwordNew').hasError('numericChar'),
                                        'not-met': changePasswordForm.get('passwordNew').hasError('numericChar')
                                    }">
                                            1 número no mínimo
                                    </li>
                                    <li [ngClass]="{
                                        'met': !changePasswordForm.get('passwordNew').hasError('lowerChar'),
                                        'not-met': changePasswordForm.get('passwordNew').hasError('lowerChar')
                                    }">
                                            1 letra minúscula no mínimo
                                    </li>
                                    <li [ngClass]="{
                                        'met': !changePasswordForm.get('passwordNew').hasError('upperChar'),
                                        'not-met': changePasswordForm.get('passwordNew').hasError('upperChar')
                                    }">
                                            1 letra maiúscula no mínimo
                                    </li>
                                    <li [ngClass]="{
                                        'met': !changePasswordForm.get('passwordNew').hasError('specialChar'),
                                        'not-met': changePasswordForm.get('passwordNew').hasError('specialChar')
                                    }">
                                            1 caractere especial no mínimo
                                    </li>
                                </ul> 
                            </div>

        </div>
    </div>
</div>